// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { createGroupRequested } from '@coa/app/shared/add-to-group-dialog/modules/create-group/store/create-group.actions';

@Component({
  selector: 'coa-create-group-body',
  templateUrl: './create-group-body.component.html',
  styleUrls: ['./create-group-body.component.scss'],
})
export class CreateGroupBodyComponent {
  @Input() clientId: number;
  @Input() selections: number[];
  @Output() showAddToGroup = new EventEmitter<void>();

  control = new FormControl('', [Validators.required]);

  constructor(
    private store$: Store,
  ) {
  }


  cancel(): void {
    this.showAddToGroup.emit();
  }

  save(): void {
    this.store$.dispatch(createGroupRequested({clientId: this.clientId, name: this.control.value, selections: this.selections}));
  }
}
